export function obtenerDiferencia(year){
    return new Date().getFullYear()- year;
}

// calcular el total a pahgar segun la marca

export function calcularMarca(marca){
    let incremento;

    switch (marca) {
        case 'pacifico':
            incremento = 0.30;
            break;
        case 'rimac':
            incremento = 0.15;
            break;
        case 'mapfre':
            incremento = 0.05;
            break;

        default:
            break;
    }
    return incremento;
}

// calcular el tipo de seguro 

export function obtenerPlan(plan){
    return (plan === 'basico') ? 1.20 : 1.50;
}


// letra mayuscula primer a

export function primeraMayuscula(texto){
    return texto.charAt(0).toUpperCase()+ texto.slice(1);
}